/**
 * Explore Menu Handler
 *
 * Handles category card expansion for subcategories in the Explore menu.
 * Mobile: accordion toggle button expands/collapses subcategories.
 *         Category name link navigates to the category page.
 * Desktop: title click navigates, subcategories always visible via CSS.
 *
 * @package BudgetFitter
 */

class ExploreMenuHandler {
  constructor() {
    this.activeSubcategory = null;
    this.init();
  }

  init() {
    // Bind immediately — no need to wait for sheet events
    this.bindToggleButtons();

    // Also bind when new content might be dynamically loaded
    const observer = new MutationObserver(() => this.bindToggleButtons());
    const target = document.getElementById('sheet-explore');
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  bindToggleButtons() {
    // Mobile accordion: only the chevron button toggles. Header link
    // and sub-item links navigate normally. Card whitespace does nothing.
    const toggleButtons = document.querySelectorAll(
      '.bfwt-explore-menu__toggle:not([data-events-bound])'
    );
    toggleButtons.forEach((btn) => {
      btn.setAttribute('data-events-bound', 'true');
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const card = btn.closest('.bfwt-explore-menu__card--expandable');
        if (!card) return;
        const categoryId = card.getAttribute('data-category-id');
        this.toggleSubcategories(categoryId, card);
      });
    });
  }

  toggleSubcategories(categoryId, card) {
    const subcategoryPanel = document.getElementById(
      `subcategories-${categoryId}`
    );

    if (!subcategoryPanel) return;

    // If this panel is already open, close it
    if (subcategoryPanel.classList.contains('is-active')) {
      subcategoryPanel.classList.remove('is-active');
      card.classList.remove('is-expanded');
      this.activeSubcategory = null;
      return;
    }

    // Close any open panel first
    this.closeAll();

    // Open new panel
    subcategoryPanel.classList.add('is-active');
    card.classList.add('is-expanded');
    this.activeSubcategory = subcategoryPanel;

    // Auto-scroll to view (User Request: "Expand edince focus olmalı")
    setTimeout(() => {
      card.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }, 300); // Wait for expansion animation
  }

  closeAll() {
    document
      .querySelectorAll('.bfwt-explore-menu__subcategories.is-active')
      .forEach((panel) => panel.classList.remove('is-active'));
    document
      .querySelectorAll('.bfwt-explore-menu__card--expandable.is-expanded')
      .forEach((card) => card.classList.remove('is-expanded'));
    this.activeSubcategory = null;
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.exploreMenuHandler = new ExploreMenuHandler();
  });
} else {
  window.exploreMenuHandler = new ExploreMenuHandler();
}
